/* eslint-disable default-case */
import { EmUserProfile, Settings, EmUserProfileLocation } from '../../components/common/interfaces/types';

import { 
    AUTH_LOGIN, 
    SET_AUTHENTICATED_USER_DATA,  
    AuthLoginActionType, 
    SetAuthUserDataType, 
    DID_SET_USER_PREFERENCES, 
    DidSetUserPreferencesType,
    ResetLoggedOutUserActionType,
    RESET_LOGGED_OUT_USER_DATA } from '../actions/authActions';

export interface AuthState {
    userName?: string;
    accessToken?: string;
    refreshToken?: string;
    isLoggedIn: boolean;
    error?: boolean | Record<string, unknown> | unknown;
    userSettings?: Settings;
    userSavedLocations?: EmUserProfileLocation[];
    didSetUserPreferences: boolean;
}

const initialState: AuthState = {
    isLoggedIn: false,
    didSetUserPreferences: false
};

export type AuthActionTypes = | SetAuthUserDataType | AuthLoginActionType | DidSetUserPreferencesType | ResetLoggedOutUserActionType;

export function userAuth(state = initialState, action: AuthActionTypes): AuthState
{
    switch (action.type)
    {
        case SET_AUTHENTICATED_USER_DATA: 
        {
            const { userName, accessToken, refreshToken } = action.payload;
            const isUserAuthenticated = !!(userName && accessToken && refreshToken);
            return {
                ...state,
                isLoggedIn: isUserAuthenticated,
                userName,
                accessToken,
                refreshToken
            };
        }
        case AUTH_LOGIN.pending:
        {
            return {
                ...state,
                isLoggedIn: false,
                error: false
            };
        }
        case AUTH_LOGIN.fulfilled:
        {
            const { UserInfo, Settings, Locations } = action.payload as unknown as EmUserProfile;
            const { FirstName, LastName, Email } = UserInfo ?? {};

            let userName = `${FirstName} ${LastName}`;
            if (!FirstName && !LastName && Email)
            {
                const formattedEmail = Email?.split('@')[0];
                userName = formattedEmail;
            }
            return {
                ...state,
                isLoggedIn: true,
                userName,
                userSavedLocations: Locations,
                userSettings: Settings,
                error: false
            };
        }
        case AUTH_LOGIN.rejected:
        {
            return {
                ...state,
                isLoggedIn: false,
                error: true
            };
        }

        case DID_SET_USER_PREFERENCES:
        {
            return {
                ...state,
                didSetUserPreferences: true
            };
        }

        case RESET_LOGGED_OUT_USER_DATA:
        {
            return {
                ...state,
                userName: undefined,
                accessToken: undefined,
                refreshToken: undefined,
                isLoggedIn: false,
                error: undefined,
                userSettings: undefined,
                userSavedLocations: undefined,
                didSetUserPreferences: false
            };
        }
    }

    return state;
}
